<div *ngIf="!chooseOptions" class="upload-btn"><ng-container *ngTemplateOutlet="uploadButton;context:{template: uploadImg, text: 'Upload Document'}"></ng-container></div>

<ng-template #uploadButton let-template="template" let-text="text">
  <button type="button" class="upload-btn" (click)="openModal(template, text)" mat-button>
    <i class="material-icons">add_photo_alternate</i> <span>Add</span>
  </button>
</ng-template>

<ng-template #uploadImg>
  <div class="upload-wrapper">
    <button  mat-button *ngIf="!previewImg" class="add-photo" (click)="fileInput.click()">
      <i class="material-icons">add_photo_alternate</i>
    </button>
    <div *ngIf="previewImg" class="img-preview-wrapper">
      <button (click)="closePreview()" mat-icon-button>
        <i class="material-icons">cancel</i>
      </button>
      <img class="preview-img" *ngIf="!isCropper" [src]="previewImg">
      <angular-cropper *ngIf="isCropper"
        #cropper
        [cropperOptions]="options"
        [imageUrl]="previewImg">
      </angular-cropper>
    </div>
    <div *ngIf="isCropper" class="upload-info">
      This is the image that will feature right on the top of your page. Make it impactful!! <br>PNG, JPG or BMP (recommended 700 x 400 pixels)
    </div>
    <form [formGroup]="imgForm" (ngSubmit)="submitMedia()">
      <div class="help-text mt-3">
        <div class="text">
          Help
        </div>
        <mat-icon (click)="showPopover = true" class="style-as-link">help</mat-icon>
      </div>
      <div *ngIf="selectOptions" >
        <app-select [group]="imgForm" [control]="imgForm.get('imgType')" [placeHolder]="'Select Document type'" [data]="selectOptions"></app-select>
      </div>
      <div class="cost-estimation">
        <app-input inputType="number" [errorMessage]="info?.uploadImg?.error" label="Overall Treatment Cost (in Rupees)" placeHolder="₹" [group]="imgForm" [control]="imgForm.get('costEst')"></app-input>
      </div>
      <div class="hint">
        {{ info.medicalPopoverContent.hint_medical_file }}
      </div>
      <input class="d-none" type="file" accept="image/*,.pdf" formControlName="imgControl" (change)="onFileChanged($event)" name="file_upload_input" #fileInput>
      <small *ngIf="fileStatus?.error">{{fileStatus?.message}}</small>
      <small *ngIf="imgForm.get('imgControl').hasError('required') && imgForm.get('imgControl').touched">Please upload file</small>
      <app-button type="submit" [label]="label" btnClass="button-primary filled full-width" [isLoading]="isLoading"></app-button>
    </form>
  </div>
</ng-template>


<app-popover-loader *ngIf="showPopover" [show]="showPopover" [config]="{popupClass: 'input-popover', title: info?.medicalPopoverContent?.title, desc: info?.medicalPopoverContent?.desc, eg: info?.medicalPopoverContent.see_egs, class: 'v5'}" (hideel)="showPopover = $event"></app-popover-loader>
